import { createFileRoute } from "@tanstack/react-router";
import { HomePage } from "~/components/HomePage";

export const Route = createFileRoute("/")({
	beforeLoad: () => {
		document.title = "bacehub | Startseite";
	},
	component: RouteComponent,
});

export default function RouteComponent() {
	return <HomePage />;
}
